<template>
  <div class="register main-login">
    <div class="title">
      <h1>课玩<span> 端应用</span></h1>
      <p>注册帐号去探索一场超级旅行吧</p>
    </div>

    <div class="register-form">
      <input type="text" v-model="username" placeholder="请输入手机号码" class="username" />
      <div class="code-box">
        <input type="text" v-model="code" placeholder="请输入验证码" class="code" />
        <button v-if="count === 0" class="code-btn" @click="getPhoneCode()">获取验证码</button>
        <button v-else class="code-btn" disabled>{{ count }}秒后重试</button>
      </div>
      <input type="password" v-model="password" placeholder="设置密码" class="password" />
      <input type="password" v-model="repeatPassword" placeholder="重复密码" class="repeat-password" />
      <input type="text" v-model="nickname" placeholder="请输入昵称 / 姓名" class="nickname" />
      <button class="register-btn" @click="register()">注 册</button>

      <div class="go-login">已有帐号? <a @click="goLogin()">去登录</a></div>
    </div>

    <div class="record">
      <a target="_blank" href="https://beian.miit.gov.cn/">黔ICP备18006806号-2 超级课玩 lessonplay.cn</a>
    </div>
  </div>
</template>

<script>
import { hasMysqlUtf8UnsupportedChar } from '../../util/validate'

export default {
  name: "register",
  props: {
    redirectURI: String,
  },
	data() {
		return {
      username: '',
      code: '',
      codeGuid: '',
      nickname: '',
      password: '',
      repeatPassword: '',
      count: 0,
      countTime: null
		}
  },
  methods: {
    getAccountType() {
      if( /^1[3456789]\d{9}$/.test(this.username) ) {
        return 'phone'
      }
      return null
    },

    async register() {
      const accountType = this.getAccountType()

      if(
        !this.username ||
        !this.code ||
        !this.nickname ||
        !this.password ||
        !this.repeatPassword
      ) {
        return this.$message.warning('信息填写不完整')
      }

      if(!accountType) { 
        return this.$message.warning('请输入合法的手机号')
      }

      if(this.password !== this.repeatPassword) {
        return this.$message.warning('两次密码输入不一致')
      }

      if(
        hasMysqlUtf8UnsupportedChar(this.username) ||
        hasMysqlUtf8UnsupportedChar(this.nickname) ||
        hasMysqlUtf8UnsupportedChar(this.password)
      ) {
        return this.$message.warning('用户名、昵称或密码不能包含 emoji、生僻字等特殊字符')
      }

      if(!this.codeGuid) {
        return this.$message.warning('请先获取验证码')
      }

      const checkCodeRet = await this.$api.account.checkcode(this.codeGuid, this.code)
      if(checkCodeRet.code !== 1) {
        this.code = ''
        this.codeGuid = ''
        return this.$message.warning(checkCodeRet.msg || '验证码错误')
      }

      const registerRet = await this.$api.account.register({
        Name: this.username,
        NickName: this.nickname,
        Password: this.password,
        Phone: this.username,
      })

      if(registerRet.status !== 1) {
        return this.$message.warning(registerRet.err)
      }
      this.$message.success('注册成功')
      this.goLogin()
    },

    goLogin() {
      this.$router.push({ name: 'login', query: { redirectURI: this.redirectURI } })
    },

    async getPhoneCode() {
      if(!/^1[3456789]\d{9}$/.test(this.username)) {
        return this.$message.warning('请输入合法的手机号')
      }

      this.count = 60
      this.countTime = setInterval(() => {
        this.count -= 1
        if(this.count === 0) {
          clearInterval(this.countTime)
          this.countTime = null
        }
      }, 1000)

      const sendSmsRet = await this.$api.account.sendSms(this.username)
      if(sendSmsRet.code !== 1 || !sendSmsRet.data || !sendSmsRet.data.PK_CodeGuid) {
        clearInterval(this.countTime)
        this.countTime = null
        this.count = 0
        return this.$message.warning(sendSmsRet.msg || '验证码发送失败')
      }
      this.codeGuid = sendSmsRet.data.PK_CodeGuid
      this.$message.success('短信已发送，请注意查收')
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.register-btn{
  color: #ffffff;
}

.title {
  width: 270px;

  h1 {
    font-size: 28px;
    color: #555;

    span {
      font-size: 17px;
    }
  }
  p {
    font-size: 15px;
    color: #888;
    margin-top: 5px;
    margin-bottom: 12px;
  }
}

.register-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .code-box {
    width: 270px;
    display: flex;
    align-items: center;
    margin: 5px 0;

    input {
      flex: 1;
      width: auto;
      margin: 0;
    }

    .code-btn {
      width: 80px;
      margin: 0 0 0 8px;
      font-size: 11px;
      padding: 0;
    }
  }

  .go-login {
    font-size: 14px;
    color: #666666;
    margin-top: 20px;

    a {
      color: #f77f90;
    }
  }
}

/* 针对小屏幕移动设备 */
@media only screen and (max-height: 600px) {
  .title{
    display: none;
  }
}

/* 针对小屏幕PC */
@media only screen and (max-width: 1366px) and (max-height: 680px) {
  .title{
    display: none;
  }
}
</style>
